import { css } from "@vitality-ds/system";
export default css({
  background: "none",
  height: 32,
  marginBottom: 24,
  display: "grid",
  gridTemplateColumns: "26px 8.2rem 5.625rem 26px",
  gridGap: "$sm"
});